<template>
    <bottom-dialog v-model="show" scrollable max-width="500px" :dialog="true">
        <v-card v-if="user">
            <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                {{$translate('Change password')}}
                <v-spacer />
                <v-btn icon @click="show = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <v-text-field
                    :type="showPassword1 ? 'text' : 'password'"
                    :label="$translate('Password')"
                    v-model="password1"
                >
                    <template v-slot:append>
                        <v-btn @click="showPassword1 = !showPassword1" tabindex="-1" icon>
                            <v-icon v-if="showPassword1" >mdi-eye-off</v-icon>
                            <v-icon v-else>mdi-eye</v-icon>
                        </v-btn>
                    </template>
                </v-text-field>

                <v-text-field
                    :type="showPassword2 ? 'text' : 'password'"
                    :label="$translate('Verify password')"
                    v-model="password2"
                >
                    <template v-slot:append>
                        <v-btn @click="showPassword2 = !showPassword2" tabindex="-1" icon>
                            <v-icon v-if="showPassword2" >mdi-eye-off</v-icon>
                            <v-icon v-else>mdi-eye</v-icon>
                        </v-btn>
                    </template>
                </v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-btn class="zoezi-button-thin" block @click="save" :loading="saving" color="primary" :disabled="!passwordOk">{{$translate('Save password')}}</v-btn>
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from './BottomDialog.vue'
export default {
    name: 'zoezi-set-password',

    components: {
        BottomDialog
    },

    props: {
        value: {
            type: Boolean
        },
        user: {
            type: Object
        }
    },

    watch: {
        show: {
            immediate: true,
            handler(show, was) {
                if (show && !was) {
                    this.password1 = this.password2 = null;
                }
                this.$emit('input', show);
            }
        },
        value: {
            immediate: true,
            handler(value) {
                this.show = value;
            }
        }
    },

    computed: {
        passwordOk() {
            return this.password1 == this.password2 && this.password1 && this.password1.length >= 6;
        }
    },

    data: () => ({
        show: false,
        showPassword1: false,
        password1: null,
        showPassword2: false,
        password2: null,
        saving: false
    }),

    methods: {
        save() {
            this.saving = true;
            this.$api.post('/api/memberapi/change', {id: this.user.id, password: this.password1}).then((response) => {
                this.saving = false;
                if (response.ok) {
                    this.show = false;
                } else {
                    response.json().then(data => {
                        let text = this.$translate(data.message);
                        this.$store.commit('showSnackBar', {text});
                    })
                }
            })
        }
    }
}
</script>
